import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { goBack } from '@utils/breadcrumbs';
import ArrowBack from '@icon/ArrowBack';
import { Spacings } from '@styles/index';
import P2 from '../P2/P2';
import Link from '../Link/Link';
import IconButton from '../IconButton/IconButton';

const BreadCrumb = styled.div`
  border: 1px solid var(--color-divider);
`;

const StyledCrumbs = styled(BreadCrumb)`
  padding: ${({ $padding }) => $padding};
  transform: skew(-20deg);
  height: ${Spacings.SPACING_8B};
  background-color: var(--color-base-1);
  margin: auto ${Spacings.SPACING_6};
  cursor: pointer;
  border-radius: ${Spacings.SPACING_2B};
  @media only screen and (max-width: 47.95em) {
    display: none;
  }
`;

const Unskew = styled(P2)`
  transform: skew(20deg);
  color: var(--color-text-primary);
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 280px;
  overflow: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButton = styled(IconButton)`
  margin-right: ${Spacings.SPACING_3B};
  box-shadow: none;
  background-color: var(--color-base-1);
`;

const BreadCrumbs = ({
  tags,
  className,
  onBackClick,
  useBackClick,
  padding
}) => {
  const tagsLength = tags?.length || 0;
  const lastLink =
    tagsLength > 0 && !useBackClick ? tags?.[tagsLength - 1] : null;
  return (
    <Wrapper className={className}>
      {lastLink ? (
        <Link href={lastLink.href} as={lastLink.as}>
          <BreadCrumb as={BackButton} bgColor="var(--color-base-0)" hovDisabled>
            <ArrowBack
              size={Spacings.SPACING_4B}
              color="var(--color-text-primary)"
            />
          </BreadCrumb>
        </Link>
      ) : (
        <BreadCrumb
          as={BackButton}
          onClick={onBackClick}
          bgColor="var(--color-base-0)"
          hovDisabled
        >
          <ArrowBack
            size={Spacings.SPACING_4B}
            color="var(--color-text-primary)"
          />
        </BreadCrumb>
      )}

      {tags?.map((tag) => (
        <StyledCrumbs $padding={padding} key={tag.title}>
          <Link href={tag.href} as={tag.as}>
            <Unskew>{tag.title}</Unskew>
          </Link>
        </StyledCrumbs>
      ))}
    </Wrapper>
  );
};

export default BreadCrumbs;

BreadCrumbs.propTypes = {
  padding: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      as: PropTypes.string,
      href: PropTypes.string.isRequired
    })
  ),
  className: PropTypes.string,
  onBackClick: PropTypes.func,
  useBackClick: PropTypes.bool
};

BreadCrumbs.defaultProps = {
  padding: `${Spacings.SPACING_2B} ${Spacings.SPACING_5B}`,
  className: '',
  tags: [],
  onBackClick: goBack,
  useBackClick: false
};
